import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { DataTypePregunta } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

export const interpret = (
    cards: AllCardsType[],
    data: DataTypePregunta,
    user: string,
    personality: NombreTarotista,
    type: string
) => {
    let consult = `Por favor, realiza una interpretación de la Tirada del Renacer al Propósito - Gran Viaje del Alma de Tarot en un lenguaje sencillo de entender, pero hazla lo más detallada y extensa posible. Intenta ser lo más clara posible, para que esta interpretación le otorgue una visión clara, para ${data.consultante.name} de signo zodiacal ${data.consultante.zodiac}, teniendo en cuenta su signo zodiacal y su personalidad número ${data.consultante.personality} según la numerología. ${
        data.consulta.length > 0
            ? 'Al final de la interpretación, agrega una sección titulada "Foco en tu inquietud específica" donde respondas de forma concreta y definitiva a: ' +
              data.consulta
            : ''
    } Organiza la tirada de la siguiente forma: 

1. El peso actual: (Lo Consciente) ${formatCardLabel(cards[0])} y (Lo Inconsciente) ${formatCardLabel(cards[1])}

2. Raíz profunda del vacío: (Origen Principal) ${formatCardLabel(cards[2])} y (Influencia Kármica o Energética) ${formatCardLabel(cards[3])}

3. El pasado que aún pesa: (Evento o Ciclo Clave) ${formatCardLabel(cards[4])} y (Lección no Integrada) ${formatCardLabel(cards[5])}

4. La sombra ignorada: (Aspecto Reprimido) ${formatCardLabel(cards[6])} y (Cómo se manifiesta hoy) ${formatCardLabel(cards[7])}

5. La chispa que sobrevive: (Fuerza o Deseo interno) ${formatCardLabel(cards[8])} y (Cómo nutrirla) ${formatCardLabel(cards[9])}

6. Recursos internos disponibles: (Fortaleza Principal) ${formatCardLabel(cards[10])} y (Recurso secundario) ${formatCardLabel(cards[11])}

7. El propósito que llama: (Propósito de esta etapa) ${formatCardLabel(cards[12])} y (Propósito mayor del Alma) ${formatCardLabel(cards[13])}

8. Apoyo externo y oportunidades: (Personas o situaciones aliadas) ${formatCardLabel(cards[14])} y (Oportunidad que se abrirá) ${formatCardLabel(cards[15])}

9. Qué soltar – Liberación de lo que ya no es para mí: (Hábito, creencia, relación o actividad que debes dejar ir) ${formatCardLabel(cards[16])} y (Alivio y ganancia energética al soltarlo) ${formatCardLabel(cards[17])}

10. El obstáculo principal: (Desafío actual) ${formatCardLabel(cards[18])} y (Cómo transformarlo en fuerza) ${formatCardLabel(cards[19])}

11. Pasos de apertura: (Acción inmediata – esta semana/mes) ${formatCardLabel(cards[20])} y (Acción a mediano plazo – 3 a 6 meses) ${formatCardLabel(cards[21])}

12. El renacer emocional: (Felicidad y ligereza que llegarán) ${formatCardLabel(cards[22])} y (Cómo se sentirá el alma al renacer) ${formatCardLabel(cards[23])}

13. Visión futura completa: (Resultado probable del camino) ${formatCardLabel(cards[24])} y (Mensaje protector del Universo) ${formatCardLabel(cards[25])}.

Dirígete directamente al consultante en segunda persona, con tono cálido, empático y sanador.`

    let info = {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer: data.consulta,
        cards,
        type,
    }

    return info
}
